// Import Core
import React from 'react';
import styled from 'styled-components';

const ProductSpecialOffersStyling = styled.div`
	display: flex;
	flex-direction: column;
	align-items: flex-start;
	gap: 24px;
	width: 100%;
	.offers {
		background-color: var(--blue-10);
		display: flex;
		padding: 24px;
		flex-direction: column;
		align-items: flex-start;
		gap: 24px;
		.offer {
			color: var(--blue);
		}
	}
`;

const ProductSpecialOffers = ({ specialOffers }) => {
	return (
		<ProductSpecialOffersStyling className='special-offers'>
			<h3>Special Offer</h3>
			<div className='offers'>
				{specialOffers.map((offer, index) => (
					<p className='offer medium' key={`offer-${index}`}>
						{offer.excerpt}
					</p>
				))}
			</div>
		</ProductSpecialOffersStyling>
	);
};

export default ProductSpecialOffers;
